<template>
  <div id="app">
    <my-header></my-header>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/> 
    <my-footer></my-footer>
  </div>
</template>

<script>
import MyFooter from './views/HeaderAndFooter/MyFooter.vue'
import MyHeader from './views/HeaderAndFooter/MyHeader.vue'

export default {
  components: { MyFooter, MyHeader},
  
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
html, body {
  scroll-behavior: smooth
}
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 25px;
}

::-webkit-scrollbar-track,
body.dark::-webkit-scrollbar-thumb {
  background-color: #eee;
}
.content-box {
  margin-top: 100px;
}
body {
  margin: 0;
  padding: 0;
  min-width: 1044px;
}
.species-name {
  font-style: italic;
}
.common-name {
  font-family: 'Courier New', Courier, monospace;
}
.error-info {
  color: #de2d26; 
  font-size: calc(1.25rem + .25vw);
  font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
}
</style>
